var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact";
import { useCustomerAction } from "@/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { EnvelopeIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useContactButtonLabel } from "../hooks/useContactButtonLabel";
export const MailButton = ({ rootTestId, av_zone, legacyTrackingInfos, }) => {
    const isPreviewMode = useIsPreviewMode();
    const { customerActionExposeInteraction } = useCustomerAction();
    const { toggleModal } = useContactContext();
    const contactButtonLabel = useContactButtonLabel();
    const trackCustomerActionLeadMailInterestView = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield customerActionExposeInteraction([
            { key: "interaction", value: "openContactForm" },
        ]);
    });
    const handlePress = () => {
        if (isPreviewMode)
            return;
        trackCustomerActionLeadMailInterestView();
        toggleModal({
            av_zone,
            legacyTrackingInfos, //tracking GA3 for harvest
        });
    };
    return (_jsx(Button, { testId: `${rootTestId}.email`, variant: "primary", icon: EnvelopeIcon, iconPosition: "start", isFullWidth: true, onPress: handlePress, isDisabled: isPreviewMode, children: contactButtonLabel }));
};
